<template>
  <center class="m-10">
    <img
      :width="width"
      :height="height"
      src="/media/svg/soha/no-data.svg"
    >
    <br>
    <h4
      class="mt-4"
      style="color: var(--primary-color)"
    >
      {{ message }}
    </h4>
  </center>
</template>

<script>
export default {
  name: "NoData",
  props: {
    message: {
      type: String,
    },
    width: {
      default: "150",
    },
    height: {
      default: "150",
    },
  },
};
</script>
